const pt = {
    dayNamesShort: [
        'Dom',
        'Seg',
        'Ter',
        'Qua',
        'Qui',
        'Sex',
        'Sab'
    ],
    dayNames: [
        'Domingo',
        'Segunda',
        'Terça',
        'Quarta',
        'Quinta',
        'Sexta',
        'Sábado'
    ],
    monthNamesShort: [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez'
    ],
    monthNames: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro'
    ],
    amPm: [
        'am',
        'pm'
    ],
    DoFn: (day)=>`${day}°`
};
const humanized = {
    SECONDS_AGO: 'Há um momento',
    A_MINUTE_AGO: 'Há um minuto',
    MINUTES_AGO: (mins)=>`Há ${mins} minutos`,
    AN_HOUR_AGO: 'Há una hora',
    HOURS_AGO: (hours)=>`Há ${hours} horas`,
    A_DAY_AGO: 'Há un dia',
    DAYS_AGO: (days)=>`Há ${days} dias`,
    A_MONTH_AGO: 'Há un mês',
    MONTHS_AGO: (months)=>`Há ${months} meses`,
    A_YEAR_AGO: 'Há un ano',
    YEARS_AGO: (years)=>`Há ${years} anos`
};
const remaining = {
    SECONDS_AGO: 'um momento',
    A_MINUTE_AGO: 'um minuto',
    MINUTES_AGO: (mins)=>`${mins} minutos`,
    AN_HOUR_AGO: 'una hora',
    HOURS_AGO: (hours)=>`${hours} horas`,
    A_DAY_AGO: 'un dia',
    DAYS_AGO: (days)=>`${days} dias`,
    A_MONTH_AGO: 'un mês',
    MONTHS_AGO: (months)=>`${months} meses`,
    A_YEAR_AGO: 'un ano',
    YEARS_AGO: (years)=>`${years} anos`
};
const locales_pt = pt;
export default locales_pt;
export { humanized, remaining };
